import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from '../app.component';
import { DocChoiceComponent } from '../components/doc-choice/doc-choice.component';
import { CdcStepsComponent } from '../components/cdc-steps/cdc-steps.component';
import { LoginComponent } from '../components/login/login.component';
import { ListdocumentComponent } from '../components/listdocument/listdocument.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'choicedocument',
    component: DocChoiceComponent
  },
  {
    path: 'cdc-steps/:type',
    component: CdcStepsComponent
  },
  {
    path: 'list',
    component: ListdocumentComponent
  },
  {
    path: 'steps/:typeDoc/:type',
    component: CdcStepsComponent
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: []
})
export class RouteModule { }



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/route/route.module.ts